/**
 * Adaptor for axios
 */

import AxiosMockAdapter from 'axios-mock-adapter';
import axios from './api';
// import axios from 'ax';

const services = new AxiosMockAdapter(axios, { delayResponse: 0 });
export default services;
